import { useMutation, useQuery } from "@tanstack/react-query";
import { api, type CreateScanJobInput } from "../api/rest.js";

export function useScanJobsHistory(open: boolean) {
  return useQuery({
    queryKey: ["scan-jobs-history"],
    queryFn: () => api.listScanJobs(50),
    enabled: open,
    refetchInterval: open ? 5_000 : false,
  });
}

/** Stavy, ve kterých už nemá smysl polovat status — scan job skončil. */
export const TERMINAL_SCAN_STATUSES = new Set<string>([
  "completed",
  "completed_with_errors",
  "failed",
  "canceled",
]);

export function useStartScan() {
  return useMutation({
    mutationFn: (input: CreateScanJobInput) => api.createScanJob(input),
  });
}

export function useScanStatus(jobId: string | null) {
  return useQuery({
    queryKey: ["scan-status", jobId],
    queryFn: () => (jobId ? api.getScanJob(jobId) : null),
    enabled: Boolean(jobId),
    // refetchInterval jako funkce — po dosažení terminal stavu vrátíme `false`
    // a TanStack Query přestane polovat. Refetch se znovu rozjede, jen pokud
    // se změní `jobId` (nový scan).
    refetchInterval: (query) => {
      const data = query.state.data;
      if (!data) return 2_000;
      return TERMINAL_SCAN_STATUSES.has(data.status) ? false : 2_000;
    },
  });
}
